import type { T_LangValue } from "@/lib/models/types";
import type { I_MainState } from "@/store/modules/main/lib/models/interfaces";

export default {
  getInterfaceLang: (state: I_MainState): T_LangValue => {
    return state.interfaceLang;
  },
};
